<template>
  <v-runtime-template :template="includeTemp"/>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'

export default {
  name: 'InquiryPopup',
  components: {
    VRuntimeTemplate
  },
  props: {
  },
  data () {
    return {
      includeHtml: '',
      isInquiry: true,
      params: {
        surveyTitleData: {},
        surveyResultData: {},
        mbrFnm: '',
        emailAddr: '',
        mbrCelno: '',
        wepId: this.getStore('mmpAuth').state.saveId,
        wepApcId: this.getStore('mmpAuth').state.session.userId,
        opinId: ''
      },
      options: {
        height: '100%',
        color: '#ccc',
        opacity: 1,
        size: '.6rem',
        distance: '1rem',
        disableFadeOut: true,
        alwaysVisible: true
      }
    }
  },
  computed: {
    includeTemp () {
      return this.includeHtml
    }
  },
  mounted () {
    if (this.isInquiry) {
      setTimeout(function () {
        let opinId = document.getElementById('opinId').value
        document.getElementById('opinCnt').innerHTML = document.getElementById(opinId).value.length + '/1000'
      }, 800)
    }
  },
  async created () {
    this.getEmptyTemplate('wepInquiryPopup.html')
  },
  methods: {
    getEmptyTemplate (resourceUrl, next) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.firstSubTemplate = res
        this.includeHtml = wepHtmlToString.firstSubTemplate
      })
    },
    fnSurveyPopClose () {
      window.close()
    },
    getLayoutPopup (obj) {
      let param = {'policyNum': obj}
      this.$popup.WepPolicyModal(this.$el, param)
    },
    async fnComplete () {
      let obj = {}
      obj = this.documentValidate()
      if (obj.flag) {
        this.params.surveyTitleData = obj.title
        this.params.surveyResultData = obj.input
        this.params.surveyItemTypeData = obj.itemType
        this.params.survyScCd = '99'

        if (document.getElementById('survyTitlNm') !== null) {
          this.params.survyTitlNm = document.getElementById('survyTitlNm').value
        }

        let resultInfo = await this.$http.mmp.evalAfterSurvey(this, this.params)
        if (resultInfo.data.status !== 'OK') {
          this.commAlert(this.$t('WEP00027'))
        } else {
          let alertTitle = ''
          if (this.isInquiry) {
            alertTitle = this.$t('WEP00053')
          } else {
            alertTitle = this.$t('WEP00050')
          }
          let alertParams = { title: alertTitle, contents: '', okBtnNm: this.$t('WEP00006'), cancelBtnNm: '' }
          let confirmRes = await this.$popup.confirm(this.$el, alertParams)
          if (confirmRes) {
            window.close()
          }
        }
      }
    },
    fnLimitTextArea () {
      let opinId = document.getElementById('opinId').value
      if (document.getElementById(opinId).value.length > 1000) {
        document.getElementById(opinId).value = document.getElementById(opinId).value.substring(0, 1000)
      }
      document.getElementById('opinCnt').innerHTML = document.getElementById(opinId).value.length + '/1000'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/InquiryPopup.vue